<template>
  <div class="zoom-container">
    <h2>SconChat Zoom App</h2>
    <div v-if="meetingId" class="status success">
      <p>연결 성공!</p>
      <p>Meeting UUID: {{ meetingId }}</p>
    </div>
    <div v-else-if="errorMsg" class="status error">
      {{ errorMsg }}
    </div>
    <div v-else class="status info">Zoom SDK 초기화 중...</div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
// import zoomSdk from '@zoom/appssdk'; // SDK 임포트
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

const route = useRoute();
const { t } = useI18n();

const meetingId = ref<string | null>(null);
const errorMsg = ref<string | null>(null);

// Home URL 페이지 내 스크립트
// async function requestRTMS() {
//   try {
//     // 1. SDK 설정 및 초기화
//     const config = await zoomSdk.config({
//       capabilities: [
//         'getMeetingContext',
//         'getUserContext',
//         'onMeeting', // 미팅 이벤트 감지를 위해 권장
//         'runRenderingContext', // RTMS 활성화를 위한 필수 권한
//       ],
//     });
//     console.log('SDK Configured', config);
//
//     // 2. 미팅 정보 가져오기
//     const context = await zoomSdk.getMeetingContext();
//     meetingId.value = context.meetingID;
//
//     console.log('Meeting UUID:', context.meetingID);
//     // 이 시점에 줌 클라이언트 상단에 공유 승인 배너가 나타납니다.
//   } catch (e: any) {
//     console.error('Zoom SDK Error:', e);
//     errorMsg.value = `SDK 에러: ${e.message || e}`;
//   }
// }

onMounted(async () => {
  // 앱이 로드되면 즉시 초기화 시도
  // await requestRTMS();
});
</script>

<style scoped>
.zoom-container {
  padding: 20px;
  font-family: sans-serif;
}
.status {
  padding: 15px;
  border-radius: 8px;
  margin-top: 10px;
}
.success {
  background-color: #e8f5e9;
  color: #2e7d32;
  border: 1px solid #c8e6c9;
}
.error {
  background-color: #ffebee;
  color: #c62828;
  border: 1px solid #ffcdd2;
}
.info {
  background-color: #e3f2fd;
  color: #1565c0;
}
</style>
